import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { AssignUserPersistenceService } from '../general/assigned-to/assign-to-user.service';
import { Assignee } from '../general/assigned-to/assigned-to-service-interface';
import { DeliveryService } from '../services/delivery.service';

@Injectable()
export class DeliveryAssigneeService implements AssignUserPersistenceService {
  private deliveryId: number;
  constructor(private deliveryService: DeliveryService) {}

  setDeliveryId(deliveryId: number) {
    this.deliveryId = deliveryId;
  }

  saveAssignee(assignee: Assignee): Observable<void> {
    if (!this.deliveryId) {
      throw new Error('Delivery ID not set');
    }
    return this.deliveryService
      .update(this.deliveryId, { allocated_to: assignee.value })
      .pipe(map(() => {}));
  }

  removeAssignee(): Observable<void> {
    if (!this.deliveryId) {
      throw new Error('Delivery ID not set');
    }
    return this.deliveryService
      .update(this.deliveryId, { allocated_to: null })
      .pipe(map(() => {}));
  }
}
